module.exports = __webpack_public_path__ + "media/images/cornerstone_curve-3a073fd7ce4004a614c00964468bd155.png";